type SocialLinkParams = {
  pageLink: string;
  title: string | undefined;
};

export const getFacebookLink = ({ pageLink }: SocialLinkParams) =>
  `https://www.facebook.com/sharer/sharer.php?u=${pageLink}`;

export const getTwitterLink = ({ pageLink, title }: SocialLinkParams) =>
  `https://twitter.com/intent/tweet?url=${pageLink}&text=${title}`;

export const getPinterestLink = ({ pageLink, title }: SocialLinkParams) =>
  `https://pinterest.com/pin/create/button/?url=${pageLink}&media=&description=${title}`;

export const getWhatsappLink = ({ pageLink, title }: SocialLinkParams) =>
  `whatsapp://send?text=${pageLink} ${title}`;
